import { render } from "./SuccessLogin.vue?vue&type=template&id=3caa8e4f&scoped=true"
import script from "./SuccessLogin.vue?vue&type=script&lang=js"
export * from "./SuccessLogin.vue?vue&type=script&lang=js"

import "./SuccessLogin.vue?vue&type=style&index=0&id=3caa8e4f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3caa8e4f"

export default script